<script setup lang="ts">
import BaseSvg from '@clovyr/bed/components/icons/BaseSvg.vue';
</script>

<template>
  <BaseSvg class="icon icon-sleeping" width="18" height="18" fill="none" viewBox="0 0 18 18">
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.48"
      d="M13.9 11a6.9 6.9 0 0 1-6.75-8.3 6.46 6.46 0 1 0 8.15 8.15c-.45.1-.92.14-1.4.14Z"
    />
  </BaseSvg>
</template>
